import { render } from "./My_Profile_Modal.vue?vue&type=template&id=47c32924&scoped=true"
import script from "./My_Profile_Modal.vue?vue&type=script&lang=js"
export * from "./My_Profile_Modal.vue?vue&type=script&lang=js"

import "./My_Profile_Modal.vue?vue&type=style&index=0&id=47c32924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c32924"]])

export default __exports__